import AuthFormSwitch from './AuthFormSwitch';
import Layout from '@/components/new-order/Layout';

const AuthScreen = () => {
  return (
    <Layout>
      <AuthFormSwitch />
    </Layout>
  );
};

export default AuthScreen;
